import { useEffect } from "react";

import { useCookies } from "react-cookie";

const CLOUDFRONT_COOKIE_NAMES = [
  "CloudFront-Policy",
  "CloudFront-Key-Pair-Id",
  "CloudFront-Signature"
] as const;

const COOKIE_OPTIONS = {
  domain: ".mym.fans",
  sameSite: "none" as const,
  secure: true
};

type CloudFrontCookieName = (typeof CLOUDFRONT_COOKIE_NAMES)[number];

const setCookiesFromUrl = (
  mediaUrl: string,
  setCookies: (
    name: CloudFrontCookieName,
    value: string,
    options: object
  ) => void
) => {
  try {
    const url = new URL(mediaUrl);
    const params = new URLSearchParams(url.search);

    const policy = params.get("Policy");
    const keyPairId = params.get("Key-Pair-Id");
    const signature = params.get("Signature");

    if (!policy || !keyPairId || !signature) return;

    const cookiePath = mediaUrl.substring(
      mediaUrl.indexOf("/medias"),
      mediaUrl.lastIndexOf("/HLS") + 5
    );

    setCookies("CloudFront-Policy", policy, {
      ...COOKIE_OPTIONS,
      path: cookiePath
    });
    setCookies("CloudFront-Key-Pair-Id", keyPairId, {
      ...COOKIE_OPTIONS,
      path: cookiePath
    });
    setCookies("CloudFront-Signature", signature, {
      ...COOKIE_OPTIONS,
      path: cookiePath
    });
  } catch (error) {
    console.warn(
      "[CloudFront] Failed to set cookies from URL:",
      mediaUrl,
      error
    );
  }
};

/**
 * Sets CloudFront signed cookies from media URLs' query parameters.
 * Required for HLS video playback via CloudFront.
 * Accepts a single URL or an array of URLs.
 */
export const useCloudFrontCookies = (mediaUrls?: string | string[]) => {
  const [, setCookies] = useCookies([...CLOUDFRONT_COOKIE_NAMES]);

  useEffect(() => {
    if (!mediaUrls) return;

    const urls = Array.isArray(mediaUrls) ? mediaUrls : [mediaUrls];
    urls.forEach((url) => setCookiesFromUrl(url, setCookies));
  }, [mediaUrls, setCookies]);
};
